import { createClient } from '@supabase/supabase-js';
import { createAuthStorage, ensureRememberedAuthPreference } from './authPersistence';

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;
if (key?.startsWith('sb_secret_'))
  throw new Error('Only a Supabase publishable key belongs in browser configuration.');
if (key?.split('.').length === 3) {
  try {
    const p = JSON.parse(atob(key.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    if (p.role === 'service_role') throw new Error('SECRET');
  } catch (e) {
    if ((e as Error).message === 'SECRET')
      throw new Error('A service-role key must never be used in browser configuration.');
  }
}
ensureRememberedAuthPreference();
export const supabase =
  url && key
    ? createClient(url, key, {
        auth: {
          flowType: 'pkce',
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: false,
          storage: createAuthStorage(),
        },
      })
    : null;
export const DEMO_ALLOWED = import.meta.env.DEV || import.meta.env.VITE_ENABLE_DEMO === 'true';
export const API_BASE = import.meta.env.VITE_API_BASE_URL || '/api/v1';
